// Events
export const AMC_APPLICATION_REQUEST = "allSureMotorClaim/policyRequest/";
export const SEND_CLAIM_SUBMISSION_MAIL = AMC_APPLICATION_REQUEST+'claimSubmissionMail'
export const submitPolicy = () => ({  
  type: SEND_CLAIM_SUBMISSION_MAIL,
}); 
export const SEND_DOCUMENTS = AMC_APPLICATION_REQUEST+'uploadDocuments'
export const uploadDocumentsRequest=()=>({
  type:SEND_DOCUMENTS,
})